import { size, mediaQueries, typography, Button } from '@everlywell/leaves';
import styled from 'styled-components';

interface SectionProps {
  backgroundColor?: string;
}

interface ImageWrapperProps {
  imageHeight?: number;
  pinImageToBottom?: boolean;
  pinImageToRight?: boolean;
  useMobileImage?: boolean;
}

export const Section = styled.section<SectionProps>`
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  ${mediaQueries.forTabletVerticalUp} {
    flex-direction: row;
    padding: ${size.xl3}px;
    gap: ${size.xl3}px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    border: none;
    border-radius: ${size.xs1}px 140px 140px ${size.xs1}px;
    height: 478px;
    margin: ${size.xl2}px;
    padding: 0;
    gap: unset;
  }
`;

export const TextContainer = styled.div`
  margin: auto;
  max-width: 515px;
  padding: ${size.xl1}px ${size.xl3}px;
  width: 100%;
  z-index: 1;

  ${mediaQueries.forTabletVerticalUp} {
    align-self: center;
    width: 50%;
    margin: 0;
    padding: 0;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin: 0 5% 0 ${size.xl3}px;
    width: 185%;
    max-width: 660px;
    min-width: 355px;
    text-align: left;
  }

  ${mediaQueries.forDesktopUp} {
    margin: 0 10% 0 ${size.xl6}px;
  }
`;

export const HeadlineAndDescription = styled.div`
  margin: 0 auto;

  ${mediaQueries.forTabletVerticalUp} {
    margin: 0;
  }
`;

export const Headline = styled.h1`
  ${typography.h3Text};
  text-align: center;

  ${mediaQueries.forTabletVerticalUp} {
    text-align: left;
  }

  ${mediaQueries.forDesktopUp} {
    ${typography.h1Text};
  }
`;

export const Description = styled.div`
  ${typography.bodyTextSmall}
  display: block;
  padding-top: ${size.lg}px;
  text-align: center;

  ${mediaQueries.forTabletVerticalUp} {
    ${typography.bodyText}
    padding-top: ${size.md}px;
    text-align: left;
  }

  ${mediaQueries.forDesktopUp} {
    ${typography.h4Text}
  }
`;

export const CTAWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const MainCTA = styled(Button)`
  border-radius: ${size.xs2}px;
  margin: ${size.lg}px auto;

  ${mediaQueries.forTabletVerticalUp} {
    border-radius: unset;
    margin: ${size.lg}px 0 0 0;
  }
`;

export const ImageWrapper = styled.div<ImageWrapperProps>`
  display: ${(props) => (props.useMobileImage ? 'none' : 'flex')};
  height: auto;
  justify-content: center;
  margin: 0 auto;
  padding-bottom: ${(props) => (props.pinImageToBottom ? 0 : 32)}px;
  width: 200px;

  .gatsby-image-wrapper img {
    left: ${(props) => (props.pinImageToRight ? 'unset' : '')};
    margin: 0 auto;
    right: ${(props) => (props.pinImageToRight ? 0 : '')};
    width: 100%;
  }

  ${mediaQueries.forTabletVerticalUp} {
    align-self: ${(props) => (props.pinImageToBottom ? 'flex-end' : 'center')};
    display: flex;
    height: ${(props) => props.imageHeight || 100}%;
    justify-content: unset;
    margin: unset;
    padding-bottom: 0;
    width: 50%;

    .gatsby-image-wrapper img {
      width: 100%;
    }
  }

  ${mediaQueries.forTabletHorizontalUp} {
    width: unset;

    .gatsby-image-wrapper img {
      width: auto;
    }
  }
`;

export const MobileImageWrapper = styled.div`
  display: flex;
  height: auto;
  justify-content: center;
  margin: 0 auto;
  width: 200px;

  ${mediaQueries.forTabletVerticalUp} {
    display: none;
  }
`;
